import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
// import HomePage from './components/HomePage';
import SupportPage from './components/SupportPages/SupportPage';
import SupportPageHe from './components/SupportPages/SupportPageHe';
import Hatmada from './components/Hatmada/Hatmada.js';
import BeestmodeSupportPage from './components/SupportPages/Beestmode.js';
import BeestmodePrivacyPolicyPage from './components/SupportPages/PrivacyPolicyPage.js';
import BeestmodePrivacyPolicyPageEN from './components/SupportPages/PrivacyPolicyPageEn.js';
import BeestmodeSupportPageEN from './components/SupportPages/BeestmodeEn.js';
import BeestmodeDeleteAccountPage from './components/SupportPages/BeestmodeDeleteAccountPage.js';
import AdminDashboardApp from './components/SupportPages/BeestmodeAdminDashboard.js';
import PsychologistLandingPage from './components/Michael/psychologistLandingPage.js';
import BeestmodeReferralLandingPage from './components/BeestmodeReferralLandingPage.js';
import BeestmodeCampaignLandingPage from './components/BeestmodeCampaignLandingPage.js';
import MyShoppingListJoinPage from './components/MyShoppingListJoinPage.js';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<BeestmodeCampaignLandingPage />} />
          <Route path="/where2exitSupport" element={<SupportPage />} />
          <Route path="/where2exitSupport/He" element={<SupportPageHe />} />
          <Route path="/hatmada" element={<Hatmada />} />
          <Route path="/michael-therapy" element={<PsychologistLandingPage />} />
          <Route path="/beestmode" element={<BeestmodeSupportPage />} />
          <Route path="/beestmodeen" element={<BeestmodeSupportPageEN />} />
          <Route path="/beestmodeprivacy" element={<BeestmodePrivacyPolicyPage />} />
          <Route path="/beestmodeprivacyen" element={<BeestmodePrivacyPolicyPageEN />} />
          <Route path="/beestmode/delete-account" element={<BeestmodeDeleteAccountPage />} />
          <Route path="/invite/:referralCode" element={<BeestmodeReferralLandingPage />} />
          <Route path="/invite" element={<BeestmodeReferralLandingPage />} />
          <Route path="/template-share/:shareId" element={<BeestmodeReferralLandingPage />} />
          <Route path="/list/:shareCode" element={<MyShoppingListJoinPage />} />
          <Route path="/list" element={<MyShoppingListJoinPage />} />
          <Route path="/download" element={<BeestmodeCampaignLandingPage />} />
          <Route path="/beestmode/download" element={<BeestmodeCampaignLandingPage />} />
          <Route 
            path="/beestmodeadmindashboard" 
            element={
              <AuthProvider>
                <AdminDashboardApp />
              </AuthProvider>
            } 
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
